import { useEffect } from 'react';
import { useSession } from '@/contexts/LitSessionProvider';
import { useUserCloudQuery } from '@/hooks/onboarding/useReferralQuery';
export default function useGetUserProfileInfo() {
  var _a, _b, _c, _d, _e;
  const {
    PKP,
    setPKP
  } = useSession();
  const {
    data: userCloudData
  } = useUserCloudQuery();
  const PFP = `/static/genie/${(_a = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _a === void 0 ? void 0 : _a.pfp}`;
  const firstName = (_b = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _b === void 0 ? void 0 : _b.first_name;
  const lastName = (_c = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _c === void 0 ? void 0 : _c.last_name;
  const userName = (_d = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _d === void 0 ? void 0 : _d.username;
  const userId = (_e = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _e === void 0 ? void 0 : _e.user_id;
  useEffect(() => {
    if ((firstName, lastName, userName) && (PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) && (PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress) && (PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress)) {
      setPKP(Object.assign(Object.assign({}, PKP), {
        firstName: firstName,
        lastName: lastName,
        username: userName
      }));
    }
  }, [firstName, lastName, userName, PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress, PKP === null || PKP === void 0 ? void 0 : PKP.additionalEthAddress, PKP === null || PKP === void 0 ? void 0 : PKP.solanaAddress]);
  return {
    PFP,
    firstName,
    lastName,
    userName,
    userId
  };
}